import baseapi from "./../baseAPI";
import {successMesg, errorMesg, infoMessage, warningMesg} from "./../../Pages/Toaster";

export const DashboardAPI = async (setFreshLeadCount, setWarmLeadCount, setPendingFollowup, setTodayFollowup, setNotifications, setCallerData, setLoading) =>
{
    //setLoading(true);    

    try 
    {
        const [freshcount, warmcount, pendingcount, todaycount, followupdata, callerlist] = await Promise.all([
                                                                      baseapi.get("/api/team/dashboard/fresh-lead-count"),
                                                                      baseapi.get("/api/team/dashboard/warm-lead-count"),
                                                                      baseapi.get("/api/team/dashboard/pending-followup-count"),
                                                                      baseapi.get("/api/team/dashboard/today-followup-count"),
                                                                      baseapi.get("/api/team/dashboard/today-followup"),
                                                                      baseapi.get("/api/team/dashboard/caller-matrix"),
                                                                ]);

        //console.log(warmcount.data.datacount);
        setFreshLeadCount(freshcount.data.datacount);
        setWarmLeadCount(warmcount.data.datacount);
        setPendingFollowup(pendingcount.data.datacount);
        setTodayFollowup(todaycount.data.datacount);
        
        setNotifications(followupdata.data.datalist);
        setCallerData(callerlist.data.callerdata);

        setLoading(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }

}

export const DashboardFilterAPI = async (filterparams, setFreshLeadCount, setWarmLeadCount, setPendingFollowup, setTodayFollowup, setNotifications, setLoading, setFilterParam) =>
{
    //setLoading(true);    

    let searchparam = "";

    if(filterparams !== "" && filterparams !== null && filterparams !== undefined)
    {
        searchparam = `?${filterparams.toString()}`;
    }
    else
    {
        searchparam = "";
    }

    try 
    {
        const [freshcount, warmcount, pendingcount, todaycount, followupdata] = await Promise.all([
                                                                      baseapi.get("/api/team/dashboard/fresh-lead-count" + searchparam),
                                                                      baseapi.get("/api/team/dashboard/warm-lead-count" + searchparam),
                                                                      baseapi.get("/api/team/dashboard/pending-followup-count" + searchparam),
                                                                      baseapi.get("/api/team/dashboard/today-followup-count" + searchparam),
                                                                      baseapi.get("/api/team/dashboard/today-followup" + searchparam),         
                                                                ]);

        //console.log(warmcount.data.datacount);
        setFreshLeadCount(freshcount.data.datacount);
        setWarmLeadCount(warmcount.data.datacount);
        setPendingFollowup(pendingcount.data.datacount);
        setTodayFollowup(todaycount.data.datacount);
        
        setNotifications(followupdata.data.datalist);

        setFilterParam('?' + filterparams);

        setLoading(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }

}

export const getCampaignsAPI = async (setCampaigns) =>
{
    //setLoading(true);

    try 
    {
        const response = await baseapi.get("/api/team/filter/campaigns");

        console.log("Campaign Data=====", response.data.datalist);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setCampaigns(response.data.datalist);
        //setLoading(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}

export const getCallersAPI = async (campaignid, setCallers) =>
{
    //setLoading(true);

    try 
    {
        const response = await baseapi.get("/api/team/filter/callers/" + campaignid);

        console.log("Caller Data=====", response.data.datalist);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setCallers(response.data.datalist);
        //setLoading(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}

export const DashboardAPIOLD = async (setFreshLeadCount, setWarmLeadCount, setContactedLeadCount, setDeadLeadCount, setColdLeadCount, setAttemptLeadCount, setEnrolledLeadCount, setTotalLeadCount, setPendingFollowup, setTodayFollowup, setNotifications, setCallerData, setLoading) =>
{
    //setLoading(true);    

    try 
    {
        const response = await baseapi.get("/api/team/dashboard");

        console.log("Data got successfully", response.data);
        
        setFreshLeadCount(response.data.datalist.freshlead);
        setWarmLeadCount(response.data.datalist.warmleads);
        setContactedLeadCount(response.data.datalist.contactedleads);
        setDeadLeadCount(response.data.datalist.deadleads);
        setColdLeadCount(response.data.datalist.coldleads);
        setAttemptLeadCount(response.data.datalist.attemptleads);
        setEnrolledLeadCount(response.data.datalist.enrolledleads);
        setTotalLeadCount(response.data.datalist.totallead);
        setPendingFollowup(response.data.notification.total_pending);
        setTodayFollowup(response.data.notification.today_pending);
        setNotifications(response.data.todaynotification);

        setCallerData(response.data.callersdata);

        setLoading(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }

}

